import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import descriptionTextBg from '../../../images/Group 1.png';
import './AboutDescription.css';

const descriptionHeadTextBg = {
    backgroundImage: `url(${descriptionTextBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    paddingLeft: '2%'
}

const AboutDescription = () => {
    return (
        <div id="aboutLeftBd">
            <Box id="aboutRightBg">
                <Container>
                    <Box sx={{ textAlign: 'left' }}>
                        <Typography variant="h3" style={descriptionHeadTextBg} id="service-title" sx={{ py: 2, color: '#000D83', fontSize: '40px', fontWeight: 600 }}>
                            We Build super natural connections
                        </Typography>
                        <Box sx={{ px: '2%' }}>
                            <Typography variant="p" sx={{ color: '#454545', fontSize: '18px' }} id="quote-button">
                                Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipiscing Amet pharetra, maecena. Lorem ipsum dolor sit amet, maecena. Amet pharetra, dada kuthey. Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. Amet pharetra, maecena. Consectetur adipiscing Amet pharetra, maecena.
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ textAlign: 'left', py: 9 }}>
                        <Typography variant="h3" style={descriptionHeadTextBg} id="service-title" sx={{ py: 2, color: '#000D83', fontSize: '40px', fontWeight: 600 }}>
                            We work with a unified project goal
                        </Typography>
                        <Box sx={{ px: '2%' }}>
                            <Typography variant="p" sx={{ color: '#454545', fontSize: '18px' }} id="quote-button">
                                Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipiscing Amet pharetra, maecena. Lorem ipsum dolor sit amet, maecena. Amet pharetra, dada kuthey. Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. Amet pharetra, maecena. Consectetur adipiscing Amet pharetra, maecena.
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ textAlign: 'left', pb: 3 }}>
                        <Typography variant="h3" style={descriptionHeadTextBg} id="service-title" sx={{ py: 2, color: '#000D83', fontSize: '40px', fontWeight: 600 }}>
                            We share common values of respect and collaboration
                        </Typography>
                        <Box sx={{ px: '2%' }}>
                            <Typography variant="p" sx={{ color: '#454545', fontSize: '18px' }} id="quote-button">
                                Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipiscing Amet pharetra, maecena. Lorem ipsum dolor sit amet, maecena. Amet pharetra, dada kuthey. Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. Amet pharetra, maecena. Consectetur adipiscing Amet pharetra, maecena.
                            </Typography>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </div>
    );
};

export default AboutDescription;